var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.logs.length)?_c('section',{attrs:{"id":"installation-report-backups"}},[_c('h5',{staticClass:"text-center mb-4"},[_vm._v(" "+_vm._s(_vm.translate("Files & Database Backups"))+" ")]),_c('heatmap',{attrs:{"from-date":_vm.fromDate,"to-date":_vm.toDate,"values":_vm.values,"colors":_vm.colors,"tooltips":_vm.tooltips}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }